import * as React from "react";
import type { SVGProps } from "react";
const PlaySvg = (props: SVGProps<SVGSVGElement>) => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clip-path="url(#clip0_437_9944)">
            <path d="M1.43604 12.3301C1.43963 12.5385 1.50026 12.7419 1.61133 12.9182C1.7224 13.0945 1.87967 13.237 2.06604 13.3301C2.25215 13.4353 2.46228 13.4906 2.67604 13.4906C2.8898 13.4906 3.09994 13.4353 3.28604 13.3301L11.936 7.98018C12.1242 7.88951 12.283 7.74756 12.3942 7.57066C12.5053 7.39376 12.5642 7.18909 12.5642 6.98018C12.5642 6.77127 12.5053 6.5666 12.3942 6.3897C12.283 6.2128 12.1242 6.07085 11.936 5.98018L3.28604 0.670183C3.09994 0.565026 2.8898 0.509766 2.67604 0.509766C2.46228 0.509766 2.25215 0.565026 2.06604 0.670183C1.87967 0.763372 1.7224 0.90586 1.61133 1.08216C1.50026 1.25846 1.43963 1.46184 1.43604 1.67018V12.3301Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_437_9944">
                <rect width="14" height="14" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export default PlaySvg;
